// src/components/Navbar/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import './Navbar.css';
import logo from '../../assets/logoemre.jpeg'; 

function Navbar() {
  const [click, setClick] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Mobilde açılır menü kontrolü için

  // Hamburger menüye tıklanınca aç/kapat
  const handleClick = () => setClick(!click);

  // Menüdeki herhangi bir linke tıklanınca tüm menüleri tamamen kapatır
  const closeMobileMenu = () => {
    setClick(false);
    setDropdownOpen(false); 
  };

  // Mobilde "Çalışma Alanları" yazısına tıklayınca alt menüyü açıp kapatır
  const toggleDropdown = () => {
    if (window.innerWidth <= 768) {
      setDropdownOpen(!dropdownOpen);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Sol Kısım: Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src={logo} alt="Avukat Emre Uygun Logo" className="logo-image" />
        </Link>

        {/* Hamburger İkonu (Sadece Mobilde Görünecek) */}
        <div className="menu-icon" onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'}>
            {click ? '✕' : '☰'}
          </i>
        </div>

        {/* Sağ Kısım: Menü Linkleri */}
        <ul className={click ? 'navbar-menu active' : 'navbar-menu'}>
          <li className="navbar-item">
            <Link to="/" className="navbar-links" onClick={closeMobileMenu}>
              Ana Sayfa
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/hakkimizda" className="navbar-links" onClick={closeMobileMenu}>
              Hakkımızda
            </Link>
          </li>
          
          {/* AÇILIR MENÜ (DROPDOWN) */}
          <li className="navbar-item dropdown">
            <div className="navbar-links" onClick={toggleDropdown}>
              Çalışma Alanları <span className="dropdown-arrow">{dropdownOpen && window.innerWidth <= 768 ? '▲' : '▼'}</span>
            </div>
            
            {/* Mobilde dropdownOpen state'ine göre 'active' class'ı alır */}
            <ul className={dropdownOpen ? "dropdown-menu active" : "dropdown-menu"}>
              <li>
                <Link to="/calisma-alanlari/ceza-hukuku" className="dropdown-link" onClick={closeMobileMenu}>Ceza Hukuku</Link>
              </li>
              <li>
                <Link to="/calisma-alanlari/aile-hukuku" className="dropdown-link" onClick={closeMobileMenu}>Aile ve Boşanma Hukuku</Link>
              </li>
              <li>
                <Link to="/calisma-alanlari/ticaret-hukuku" className="dropdown-link" onClick={closeMobileMenu}>Şirketler ve Ticaret Hukuku</Link>
              </li>
              <li>
                <Link to="/calisma-alanlari/is-hukuku" className="dropdown-link" onClick={closeMobileMenu}>İş ve Sosyal Güvenlik Hukuku</Link>
              </li>
              <li>
                <Link to="/calisma-alanlari/icra-hukuku" className="dropdown-link" onClick={closeMobileMenu}>İcra ve İflas Hukuku</Link>
              </li>
              <li>
                <Link to="/calisma-alanlari/gayrimenkul-hukuku" className="dropdown-link" onClick={closeMobileMenu}>Gayrimenkul Hukuku</Link>
              </li>
            </ul>
          </li>

          {/* Blog / Makaleler Sayfa Linki */}
          <li className="navbar-item">
            <Link to="/blog" className="navbar-links" onClick={closeMobileMenu}>
              Blog
            </Link>
          </li>

          <li className="navbar-item">
            <Link to="/iletisim" className="navbar-links" onClick={closeMobileMenu}>
              İletişim
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;